import React from 'react';
import BasePrompt from '../../base/prompt/BasePrompt';
import './RecurringMessageSendToAllAgainPrompt.scss';

const RecurringMessageSendToAllAgainPrompt = ({
  show,
  onHide,
  onConfirm,
}) => {
  return (
    <BasePrompt
      show={show}
      closeAction={onHide}
      rightButton={{
        text: 'Send to All Target Customers & Save',
        action: () => onConfirm(true),
      }}
      centerButton={{
        text: 'Send to Unreached Customers Only & Save',
        action: () => onConfirm(false),
        class: 'recurring-message-send-to-all-again-center-button'
      }}
      leftButton={{
        text: 'Cancel',
        action: onHide,
      }}
      title={'Reminder'}
      description={'The campaign has been edited, do you want to resend the message to the customer who has already received?'}
    />
  );
}

export default RecurringMessageSendToAllAgainPrompt;
